import { z } from 'zod';
export const taxManagementSettingsModel = z.object({
    collectVendorTaxes: z.boolean(),
    requireTaxInfoBeforePayment: z.boolean(),
});
export const taxManagementSettingsApiModel = z.object({
    data: taxManagementSettingsModel,
});
